import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoScn: CultureInfo = {
  name: 'scn',
  displayName: 'sicilianu',
  iso3LanguageCode: 'scn',
  iso2LanguageCode: 'scn',
  ietfLanguageTag: 'scn',
  parent: null
};
